import React from 'react';
import { MUSCLE_TO_BODY_PART } from '../../constants/exerciseCategories';
import { colors as theme } from '../../theme';

const BodyDiagram = ({ muscleGroups }) => {
  const highlightedParts = new Set();

  muscleGroups.forEach(muscle => {
    const bodyPart = MUSCLE_TO_BODY_PART[muscle];
    if (bodyPart) {
      if (Array.isArray(bodyPart)) {
        bodyPart.forEach(part => highlightedParts.add(part));
      } else {
        highlightedParts.add(bodyPart);
      }
    }
  });

  if (highlightedParts.has('shoulders_all')) {
    highlightedParts.add('front_delts');
    highlightedParts.add('side_delts');
    highlightedParts.add('rear_delts');
  }
  if (highlightedParts.has('arms_all')) {
    highlightedParts.add('biceps');
    highlightedParts.add('triceps');
    highlightedParts.add('forearms');
  }
  if (highlightedParts.has('legs_all')) {
    highlightedParts.add('quads');
    highlightedParts.add('hamstrings');
    highlightedParts.add('glutes');
    highlightedParts.add('calves');
  }
  if (highlightedParts.has('core_all')) {
    highlightedParts.add('abs');
    highlightedParts.add('obliques');
  }
  if (highlightedParts.has('back_all')) {
    highlightedParts.add('lats');
    highlightedParts.add('upper_back');
    highlightedParts.add('traps');
  }

  return (
    <div style={styles.container}>
      <div style={styles.imageContainer}>
        <img
          src="/body-diagram.jpg"
          alt="Body muscle diagram"
          style={styles.bodyImage}
        />

        <svg style={styles.svgOverlay} viewBox="0 0 960 1106" preserveAspectRatio="none">
          {/* FRONT VIEW - Left Figure */}

          {/* Front Delts */}
          {highlightedParts.has('front_delts') && (
            <>
              <path d="M 332,206 L 315,212 L 320,229 L 328,247 L 341,266 L 362,271 L 369,286 L 376,263 L 375,240 L 366,222 L 352,212 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 146,207 L 167,215 L 166,233 L 155,249 L 141,268 L 125,275 L 113,298 L 104,270 L 106,244 L 114,224 L 127,210 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
            </>
          )}

          {/* Chest */}
          {highlightedParts.has('chest') && (
            <>
              <path d="M 300,215 L 316,228 L 327,248 L 336,266 L 327,279 L 316,295 L 283,306 L 256,307 L 246,300 L 245,274 L 244,253 L 246,235 L 267,222 L 281,215 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 234,235 L 234,300 L 217,308 L 180,308 L 157,292 L 148,277 L 145,270 L 160,248 L 176,226 L 188,216 L 209,220 L 224,225 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
            </>
          )}

          {/* Abs */}
          {highlightedParts.has('abs') && (
            <>
              <path d="M 297,307 L 281,336 L 284,344 L 280,380 L 271,377 L 261,380 L 248,384 L 242,373 L 244,358 L 245,342 L 244,331 L 246,319 L 251,310 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 178,308 L 196,340 L 196,349 L 199,371 L 206,375 L 225,379 L 240,384 L 236,347 L 236,331 L 233,316 L 230,311 L 205,311 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 241,342 L 240,406 L 242,427 L 256,431 L 276,426 L 280,404 L 281,381 L 283,358 L 284,338 L 260,336 L 248,336 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 195,343 L 199,372 L 198,393 L 203,423 L 220,430 L 233,427 L 238,412 L 237,384 L 237,358 L 237,344 L 234,335 L 215,337 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 240,384 L 240,499 L 254,498 L 266,474 L 272,455 L 277,427 L 281,403 L 280,381 L 262,379 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 199,378 L 204,423 L 216,475 L 228,502 L 237,502 L 238,457 L 236,427 L 237,390 L 236,383 L 217,377 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
            </>
          )}

          {/* Obliques */}
          {highlightedParts.has('obliques') && (
            <>
              <path d="M 311,355 L 304,397 L 308,421 L 309,439 L 276,462 L 280,437 L 281,411 L 284,379 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 170,360 L 196,377 L 200,403 L 199,425 L 205,457 L 190,457 L 178,452 L 170,439 L 173,415 L 178,400 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
            </>
          )}

          {/* Biceps */}
          {highlightedParts.has('biceps') && (
            <>
              <path d="M 342,269 L 329,287 L 329,307 L 340,367 L 368,380 L 373,365 L 380,356 L 376,316 L 368,283 L 362,272 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 143,273 L 124,279 L 118,295 L 110,329 L 101,356 L 108,372 L 112,385 L 124,379 L 132,373 L 148,354 L 150,323 L 154,306 L 156,294 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
            </>
          )}

          {/* Forearms */}
          {highlightedParts.has('forearms') && (
            <>
              <path d="M 348,397 L 368,409 L 396,491 L 395,504 L 388,507 L 383,510 L 372,483 L 360,459 L 356,445 L 352,435 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 114,407 L 106,436 L 94,483 L 85,511 L 103,515 L 119,479 L 130,454 L 136,419 L 140,391 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
            </>
          )}

          {/* Quads */}
          {highlightedParts.has('quads') && (
            <>
              <path d="M 306,443 L 264,654 L 260,699 L 262,726 L 272,731 L 288,707 L 297,700 L 303,708 L 309,714 L 317,705 L 336,618 L 336,563 L 332,527 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 176,467 L 219,660 L 223,698 L 224,721 L 212,731 L 200,715 L 194,704 L 188,698 L 180,703 L 171,709 L 163,703 L 154,659 L 148,610 L 143,567 L 152,516 L 163,485 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
            </>
          )}

          {/* Calves */}
          {highlightedParts.has('calves') && (
            <>
              <path d="M 274,784 L 291,808 L 294,851 L 294,897 L 284,935 L 276,903 L 270,871 L 265,851 L 267,808 L 268,795 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 209,783 L 213,859 L 210,872 L 207,895 L 204,917 L 197,938 L 188,883 L 192,839 L 194,811 L 200,796 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
            </>
          )}

          {/* BACK VIEW - Right Figure */}

          {/* Traps */}
          {highlightedParts.has('traps') && (
            <path d="M 689,123 L 704,121 L 713,123 L 730,120 L 740,124 L 742,140 L 743,155 L 746,171 L 767,180 L 804,203 L 786,219 L 762,230 L 752,238 L 761,241 L 773,250 L 768,263 L 753,293 L 732,333 L 718,343 L 704,333 L 693,310 L 682,282 L 672,257 L 667,250 L 677,237 L 652,227 L 617,208 L 646,193 L 675,179 L 690,167 L 693,147 L 693,135 L 698,124 Z"
              fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
          )}

          {/* Rear Delts */}
          {highlightedParts.has('rear_delts') && (
            <>
              <path d="M 616,207 L 642,223 L 666,232 L 676,236 L 672,244 L 660,249 L 649,257 L 627,263 L 608,272 L 594,286 L 588,304 L 582,285 L 583,258 L 586,232 L 596,216 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 807,206 L 781,224 L 764,235 L 780,249 L 798,260 L 826,268 L 839,280 L 851,301 L 858,267 L 854,241 L 844,217 L 829,207 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
            </>
          )}

          {/* Upper Back */}
          {highlightedParts.has('upper_back') && (
            <path d="M 688,174 L 718,175 L 751,176 L 804,206 L 825,208 L 816,297 L 799,309 L 777,309 L 751,297 L 744,319 L 728,339 L 720,343 L 705,335 L 695,315 L 687,301 L 670,307 L 649,315 L 632,304 L 619,288 L 618,279 L 604,213 Z"
              fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
          )}

          {/* Lats */}
          {highlightedParts.has('lats') && (
            <>
              <path d="M 686,304 L 699,331 L 713,347 L 709,364 L 697,379 L 693,393 L 693,414 L 690,421 L 672,413 L 661,400 L 652,390 L 648,371 L 643,350 L 635,337 L 621,300 L 629,311 L 642,315 L 657,316 L 670,311 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 752,302 L 741,334 L 730,342 L 722,350 L 728,367 L 739,383 L 748,396 L 748,415 L 750,423 L 762,419 L 780,408 L 787,380 L 788,362 L 799,336 L 811,319 L 814,300 L 797,310 L 779,313 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
            </>
          )}

          {/* Lower Back */}
          {highlightedParts.has('lower_back') && (
            <path d="M 717,352 L 696,383 L 692,398 L 693,421 L 693,447 L 701,453 L 705,470 L 713,483 L 720,488 L 726,480 L 729,465 L 734,455 L 740,446 L 745,443 L 744,423 L 744,402 L 740,387 Z"
              fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
          )}

          {/* Triceps */}
          {highlightedParts.has('triceps') && (
            <>
              <path d="M 616,272 L 603,281 L 594,301 L 588,325 L 583,350 L 588,383 L 592,340 L 603,340 L 608,348 L 612,359 L 614,375 L 610,395 L 623,386 L 621,358 L 630,345 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 824,271 L 818,297 L 814,319 L 809,335 L 813,355 L 815,375 L 817,387 L 828,395 L 827,359 L 832,341 L 841,341 L 848,343 L 849,363 L 850,386 L 856,343 L 851,317 L 846,303 L 838,283 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
            </>
          )}

          {/* Glutes */}
          {highlightedParts.has('glutes') && (
            <path d="M 672,439 L 648,461 L 642,479 L 635,508 L 625,546 L 622,586 L 630,591 L 638,586 L 652,564 L 673,556 L 700,549 L 716,529 L 727,539 L 744,548 L 766,554 L 781,564 L 796,572 L 804,577 L 812,575 L 815,558 L 811,534 L 804,508 L 796,486 L 792,467 L 783,457 L 773,445 L 762,439 L 747,445 L 736,455 L 731,472 L 724,485 L 719,492 L 707,471 L 701,459 L 700,450 L 686,443 Z"
              fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
          )}

          {/* Hamstrings */}
          {highlightedParts.has('hamstrings') && (
            <>
              <path d="M 711,545 L 699,651 L 696,663 L 696,678 L 699,711 L 698,747 L 691,775 L 677,734 L 668,711 L 661,724 L 655,743 L 641,771 L 643,713 L 636,598 L 646,570 L 673,556 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 726,544 L 753,551 L 805,584 L 811,604 L 811,627 L 803,665 L 795,696 L 793,732 L 792,767 L 776,723 L 770,707 L 761,726 L 752,747 L 745,773 L 737,739 L 738,694 L 738,658 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
            </>
          )}

          {/* Calves back */}
          {highlightedParts.has('calves') && (
            <>
              <path d="M 681,744 L 691,776 L 693,829 L 687,878 L 676,935 L 676,963 L 680,989 L 672,1011 L 664,1007 L 656,947 L 648,914 L 642,879 L 639,864 L 627,838 L 628,817 L 635,788 L 652,759 L 660,739 L 667,760 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
              <path d="M 775,739 L 788,767 L 800,788 L 810,821 L 809,850 L 801,885 L 792,930 L 782,951 L 776,1010 L 766,1011 L 764,949 L 758,927 L 752,904 L 750,883 L 744,869 L 745,813 L 745,783 L 756,743 L 770,767 Z"
                fill="rgba(232, 154, 60, 0.5)" stroke="none"/>
            </>
          )}
        </svg>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '24px',
    backgroundColor: theme.surface1,
    borderRadius: '14px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    marginBottom: '24px',
  },
  imageContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '100%',
    margin: '0 auto',
    backgroundColor: theme.surface1,
  },
  bodyImage: {
    width: '100%',
    maxWidth: '800px',
    height: 'auto',
    display: 'block',
    filter: 'invert(1) hue-rotate(180deg)',
    mixBlendMode: 'lighten',
  },
  svgOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
  },
};

export default BodyDiagram;
